import styled from "styled-components";
import { ThemePalette } from "../../../../../theme";

export const Column = styled.div`
  position: relative;
  height: 100%;
  background-color: ${ThemePalette.colorWhite};
  border-radius: 8px;
  overflow: hidden;
  filter: drop-shadow(0 4px 3px ${ThemePalette.colorPrimary}10)
    drop-shadow(0 2px 2px ${ThemePalette.colorPrimary}20);

  cursor: default !important;
  border: 1px solid transparent;

  .column-order {
    display: inline-block;
    background-color: ${ThemePalette.colorPrimary} !important;
    padding: 0.1rem 0.8rem;
    font-size: 0.8rem;
    font-weight: 500;
    color: ${ThemePalette.colorWhite};
  }

  .grab {
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: grab;
    font-size: 1rem;
  }

  label:not(.ant-radio-wrapper) {
    color: ${ThemePalette.colorPrimary};
    font-weight: 500;
  }
  form {
    padding: 10px 12px;
    width: 280px;
  }
`;
